import { QueryClient } from "@tanstack/react-query";

/**
 * One cache for the whole guest session.
 *
 * The menu is read on eight screens and every one of them used to refetch it:
 * walking menu, category, dish was fifteen requests for five answers, and
 * stepping back repeated the lot. Nothing here changes during a meal, so it is
 * fetched once and read from the cache after that.
 *
 * staleTime is what does the work. Within it a mount reads the cache and fires
 * nothing at all; past it the cached data still renders immediately while one
 * refetch happens behind it, so a dish repriced in the RMS still arrives.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      // Kept well past staleTime so stepping back into a screen minutes later
      // still paints from cache rather than from a spinner.
      gcTime: 30 * 60 * 1000,
      // A guest switching to their messages and back is not a reason to refetch
      // a menu, and on a phone it happens constantly.
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
